// Define page types as constants
export const TERMS_PAGE = 'terms';
export const PRIVACY_PAGE = 'privacy';
export const COOKIE_PAGE = 'cookie';

export default {
	namespaced: true,
	state: {
		pages: [],
		error: null,
	},
	getters: {
		getTermsPage: (state) => state.pages.find((page) => page.is_terms === 1),
		getPrivacyPage: (state) =>
			state.pages.find((page) => page.is_privacy === 1),
		getCookiePage: (state) =>
			state.pages.find((page) => page.is_cookie === 1),
		// Get page URL by type
		getPageUrl: (state) => (type) => {
			let page = null;

			switch (type) {
				case TERMS_PAGE:
					page = state.pages.find((p) => p.is_terms === 1);
					break;
				case PRIVACY_PAGE:
					page = state.pages.find((p) => p.is_privacy === 1);
					break;
				case COOKIE_PAGE:
					page = state.pages.find((p) => p.is_cookie === 1);
					break;
			}

			return page ? `/${page.slug}` : null;
		},
		// Simplified getPageByType that doesn't depend on other getters
		getPageByType: (state) => (type) => {
			switch (type) {
				case TERMS_PAGE:
					return state.pages.find((page) => page.is_terms === 1);
				case PRIVACY_PAGE:
					return state.pages.find((page) => page.is_privacy === 1);
				case COOKIE_PAGE:
					return state.pages.find((page) => page.is_cookie === 1);
				default:
					return null;
			}
		},
	},
	mutations: {
		setPages(state, pages) {
			state.pages = pages;
		},
		setError(state, error) {
			state.error = error;
		},
	},
	actions: {
		async fetchPages({ commit }, langId) {
			try {
				const response = await fetch(
					`${process.env.VUE_APP_API}static-pages?lang_id=${langId}`
				);
				const data = await response.json();
				if (data.status === 'OK') {
					commit('setPages', data.payload);
				}
			} catch (error) {
				commit('setError', error.message);
			}
		},

		async fetchPageContent({ commit, dispatch }, { slug, langId }) {
			try {
				if (!slug) throw new Error('fetchPageContent: slug is missing');

				const response = await fetch(
					`${process.env.VUE_APP_API}static-pages/${slug}?lang_id=${langId}`
				);

				// fetch() DOES NOT throw on 404, so handle it manually
				if (response.status === 404 && langId !== 1) {
					return dispatch('fetchPageContent', { slug, langId: 1 });
				}

				const data = await response.json();

				if (data.status === 'OK') {
					return data.payload;
				}

				return null;
			} catch (error) {
				commit('setError', error.message);
				throw error;
			}
		},

		navigateToPage({ state }, { type, router }) {
			let page = null;

			if (type === TERMS_PAGE) {
				page = state.pages.find((p) => p.is_terms === 1);
			} else if (type === PRIVACY_PAGE) {
				page = state.pages.find((p) => p.is_privacy === 1);
			} else if (type === COOKIE_PAGE) {
				page = state.pages.find((p) => p.is_cookie === 1);
			}

			if (page?.id) {
				router.push({ path: `/terms-and-conditions/${page.id}` });
				return page.id;
			}
			return null;
		},
	},
};
